export default "__VITE_ASSET__D0jcW1$___"